const colorPurple = '#5850EC';
const colorGreen = '#28a745';

const enableCPTextingStyle = {
  form: {},
  cardBox: {
    paddingTop: 10,
  },
  contentBox: {
    padding: 20,
    textAlign: 'center',
  },
  iconBox: {
    fontSize: '60px',
    marginBottom: 20,
  },
  titleBox: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: colorGreen,
    marginBottom: 15,
  },
  subtitleBox: {
    fontSize: '18px',
    color: colorPurple,
    marginBottom: 20,
  },
  descriptionBox: {
    fontSize: '16px',
    lineHeight: 1.6,
    marginBottom: 20,
    textAlign: 'left',
  },
  featuresList: {
    textAlign: 'left',
    marginBottom: 20,
    '& strong': {
      marginBottom: '12px',
      display: 'block',
    },
    '& ul': {
      listStyle: 'none',
      padding: 0,
      margin: '0 0 0 0',
      '& li': {
        marginBottom: 8,
        fontSize: '14px',
        '&:before': {
          content: '"✓ "',
          color: colorGreen,
          fontWeight: 'bold',
          marginRight: 8,
        }
      }
    }
  },
  warningBox: {
    backgroundColor: '#fff3cd',
    border: '1px solid #ffc107',
    borderRadius: 5,
    padding: 15,
    marginBottom: 20,
    fontSize: '15px',
    color: '#664d03',
    fontWeight: '500',
    lineHeight: 1.5, // Increase from 1.4 to 1.5 for more breathing room
    '& strong': {
      color: '#b45309',
      fontWeight: 'bold',
    }
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'flex-start', // Change from 'center' to 'flex-start'
    justifyContent: 'center',
    marginBottom: 20,
    fontSize: '14px',
    textAlign: 'left', // Add this for better text alignment
  },
  linkButton: {
    color: colorPurple,
    textDecoration: 'underline',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: 0,
    margin: '0 5px',
  }
};

export default enableCPTextingStyle;
